module.exports = __webpack_public_path__ + "static/media/test.2c80fdd8.png";